import { AxiosProgressEvent } from "axios";
import { getAxiosInstance } from "./axiosClient";

// Utility function to create config with optional params
const createConfig = (params?: object) => ({
  params,
});

// Generic GET request
export const get = async <T,>(url: string, params?: object): Promise<T> => {
  const axiosInstance = await getAxiosInstance();
  const config = createConfig(params);
  const response = await axiosInstance.get<T>(url, config);
  return response.data;
};

// Generic POST request
export const post = async <T,>(url: string, data: object): Promise<T> => {
  const axiosInstance = await getAxiosInstance();
  const response = await axiosInstance.post<T>(url, data);
  return response.data;
};

// Generic PUT request
export const put = async <T,>(
  url: string,
  data: object,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
): Promise<T> => {
  const axiosInstance = await getAxiosInstance();
  const config = { onUploadProgress };
  const response = await axiosInstance.put<T>(url, data, config);
  return response.data;
};

export const patch = async <T,>(url: string, data: object): Promise<T> => {
  const axiosInstance = await getAxiosInstance();
  const response = await axiosInstance.patch<T>(url, data);
  return response.data;
};

// Generic DELETE request
export const del = async <T,>(url: string): Promise<T> => {
  const axiosInstance = await getAxiosInstance();
  const response = await axiosInstance.delete<T>(url);
  return response.data;
};

export const putFileToS3 = async <T,>(
  url: string,
  data: object,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
): Promise<T> => {
  const axiosInstance = await getAxiosInstance();
  const config = {
    onUploadProgress,
    headers: {
      Authorization: undefined,
    },
  };
  const response = await axiosInstance.put<T>(url, data, config);
  return response.data;
};
